import {useMutation} from "@tanstack/react-query"

import {api, SendReplyRequest, SendReplyResponse} from "./index"

type SendReplyParams = {
	customerID: string
	conversationID: string
	providerMessageId: string
} & SendReplyRequest

export function useSendReply() {
	return useMutation({
		mutationFn: ({
			customerID,
			conversationID,
			providerMessageId,
			...payload
		}: SendReplyParams): Promise<SendReplyResponse> =>
			api.customer.sendReply(customerID, conversationID, providerMessageId, payload),
	})
}
